'use strict';

(function (numeral) {
	function AssetManager(
		$http,
		$state,
		$stateParams,
		pmtEnvService,
		$i18next,
		auth,
		pmtPageTitleService,
		pmtAlertService,
		pmtLoggerService
	) {
		let $ctrl = this;

		$ctrl.loading = true;
		$ctrl.activeFilter = 'all';
		$ctrl.mediaItems = [];
		$ctrl.isPlacesApp = pmtEnvService.isPlacesApp;
		$ctrl.uploadModalOpen = false;
		$ctrl.filesShownHere = $i18next.t('general.media_library_files_shown_here', {
			br: `<br/>`
		});

		$ctrl.onUploadAssetsOpened = () => {
			$ctrl.uploadModalOpen = true;
		};

		this.$onInit = () => {
			pmtPageTitleService.setPage($i18next.t('general.media_library'));
			$ctrl.listView = $state.params.view || auth.user.settings.mediaListView || 'list';
		};

		$ctrl.addAssetsDisabled =
			auth.user.permissions.permissions.includes('socialmedia.locationpost.manage-draft') ||
			auth.user.permissions.permissions.includes('media.manage')
				? false
				: true;

		function isDeleted(x) {
			return !!x.deleted;
		}

		function all(x) {
			return !isDeleted(x);
		}

		function isImage(x) {
			return x.contentType.startsWith('image') && !isDeleted(x);
		}

		function isVideo(x) {
			return x.contentType.startsWith('video') && !isDeleted(x);
		}

		$ctrl.filters = {
			all: {
				title: $i18next.t('general.all'),
				icon: 'fa-solid fa-folder-open',
				count: 0,
				filter: all
			},
			images: {
				title: $i18next.t('general.images'),
				icon: 'fa-solid fa-image',
				count: 0,
				filter: isImage
			},
			videos: {
				title: $i18next.t('general.videos'),
				icon: 'fa-solid fa-video',
				count: 0,
				divider: true,
				filter: isVideo
			},
			deleted: {
				title: $i18next.t('general.deleted'),
				icon: 'fa-solid fa-trash',
				count: 0,
				filter: isDeleted
			}
		};

		$ctrl.listViews = [
			{
				icon: 'fa-solid fa-table-list',
				key: 'list'
			},
			{
				icon: 'fa-solid fa-table-cells-large',
				key: 'card'
			}
		];

		const saveDefaultView = view => {
			auth.user.settings.mediaListView = view;
			$http.put('api/user/settings/' + auth.user.selectedSite.name, {
				key: 'mediaListView',
				value: view
			});
		};

		$ctrl.changeListView = view => {
			if (view) {
				$ctrl.listView = view;
				saveDefaultView(view);
			}
		};

		$ctrl.formatSize = size => numeral(size).format('0.0b');

		const getItems = () => {
			$http
				.get(`api/${$stateParams.site}/media/all`)
				.then(items => {
					$ctrl.mediaItems = items.data.data;
					$ctrl.loading = false;
					$ctrl.filters.all.count = $ctrl.mediaItems.filter(all).length;
					$ctrl.filters.images.count = $ctrl.mediaItems.filter(isImage).length;
					$ctrl.filters.videos.count = $ctrl.mediaItems.filter(isVideo).length;
					$ctrl.filters.deleted.count = $ctrl.mediaItems.filter(isDeleted).length;
				})
				.catch(res => {
					const errMsg =
						res.data?.message ||
						res.data?.error?.message ||
						res.data ||
						res.message ||
						res.error?.message ||
						'Something unexpected happened. Please refresh or navigate to another page.';
					pmtLoggerService.exceptionHandler(errMsg, 'get media/all failed');
					pmtAlertService.alert({
						title: $i18next.t('general.error_occurred'),
						body: errMsg,
						confirm: () => {
							pmtAlertService.close();
						}
					});
				});
		};

		getItems();

		$ctrl.limit = 100;
		$ctrl.loadMore = () => {
			$ctrl.limit += 50;
		};
		$ctrl.getItems = () => {
			getItems();
			$ctrl.uploadModalOpen = false;
		};

		$ctrl.mediaItemUploadUser = function (mediaItem) {
			const hasName = mediaItem && mediaItem.uploadedBy && mediaItem.uploadedBy.name;
			return hasName ? mediaItem.uploadedBy.name : '--';
		};
	}

	AssetManager.$inject = [
		'$http',
		'$state',
		'$stateParams',
		'pmtEnvService',
		'$i18next',
		'auth',
		'pmtPageTitleService',
		'pmtAlertService',
		'pmtLoggerService'
	];

	angular.module('PinMeTo.fileManager').component('pmtAssetManager', {
		templateUrl: 'pmtShared/filemanager/pmtAssetManager.html',
		controller: AssetManager
	});
})(window.numeral);
